import {CURRENCIES} from "../../App/constants/currencies";

export const getPrice = (type: string | undefined, price: number, currency: string = 'RUB'): any => {
  switch (type) {
    case 'group':
    case 'replenishment':
    case 'gift':
      return `от ${price} ${CURRENCIES[currency]}`;
    default:
      return `${price} ${CURRENCIES[currency]}`
  }
}
